import { forwardRef } from "react";
import { IconButton, type IconButtonProps } from "./IconButton";
import { Tooltip, TooltipContent, TooltipTrigger } from "./Tooltip";

export interface IconActionProps extends IconButtonProps {
  /**
   * Único string para el tooltip visible Y el `aria-label` del botón — el
   * hallazgo de accesibilidad #1 de `COMPOSICION-PANTALLAS.md` era un
   * `Tooltip` envolviendo un `ActionIcon` SIN `aria-label` propio (el
   * tooltip da `aria-describedby`, no nombre accesible). Con un solo prop
   * es imposible que el texto visible y el nombre accesible diverjan.
   */
  label: string;
  side?: "top" | "right" | "bottom" | "left";
}

/** Botón de solo ícono con tooltip · reemplaza el par `<Tooltip><ActionIcon/></Tooltip>` repetido en tablas/toolbars. */
export const IconAction = forwardRef<HTMLButtonElement, IconActionProps>(
  ({ label, side = "top", ...props }, ref) => (
    <Tooltip>
      <TooltipTrigger asChild>
        <IconButton ref={ref} aria-label={label} {...props} />
      </TooltipTrigger>
      <TooltipContent side={side}>{label}</TooltipContent>
    </Tooltip>
  )
);
IconAction.displayName = "IconAction";
